import { styled } from '@mui/system';

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'opensidebar'
})<{ opensidebar: boolean }>`
  padding: 0em;
  position: fixed;
  width: ${(props) => (props.opensidebar ? 'calc(100vw - 215px)' : '100vw')};
  height: calc(100vh - 68px);
  max-height: calc(100vh - 68px);
  left: ${(props) => (props.opensidebar ? '215px' : '')};
  overflow-y: auto;
`;
